export const SECOND_TO_MD = 1000;
